var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.109,
    height: 32.698,
    viewBox: "0 0 33.109 32.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57443",
    "data-name": "Group 57443",
    transform: "translate(-56 -135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54046",
    "data-name": "Group 54046",
    transform: "translate(56 135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 32.698,
    height: 32.698,
    transform: "translate(0.205)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "home-city",
    d: "M0,28.211V13.036l10.346-6.9,10.346,6.9V28.211H13.8V18.554H6.9v9.657H0M33.109,2V28.211H23.452V11.56l-1.38-.91V7.518H19.313V8.8L13.8,5.132V2H33.109M28.97,18.554H26.211v2.759H28.97V18.554m0-5.518H26.211V15.8H28.97V13.036m0-5.518H26.211v2.759H28.97Z",
    transform: "translate(0 1.933)",
    fill: "#0ab39c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousing);
export default __webpack_public_path__ + "static/media/housing.c6cd6e77a0a4316d1d7c95fdf2fe85a5.svg";
export { ForwardRef as ReactComponent };